import React from 'react';
import { MoviProducaoProvider } from './context/moviProducaoContext';
import { MoviProducaoContent } from './moviProducaoContent';

export const MovimentoDeProducao: React.FC = () => {
  return (
    <MoviProducaoProvider>
      <MoviProducaoContent />
    </MoviProducaoProvider>
  );
};
